module.exports = __webpack_public_path__ + "img/1929f3e2794742843d0872cba004a848.png";